/**
 * UI-only filters for Tools Dashboard leaderboards.
 * API still returns excluded users; we hide them in the UI only.
 */

import config from '../config/environment';
import { normalizeUserEmail } from './userEmail';

/**
 * Parse comma-separated emails from env into a lowercase Set.
 * @returns {Set<string>}
 */
export function getExcludedDashboardEmailSet() {
  const raw = config.DASHBOARD_EXCLUDED_USER_EMAILS || '';
  if (!String(raw).trim()) return new Set();

  return new Set(
    String(raw)
      .split(',')
      .map((email) => normalizeUserEmail(email))
      .filter(Boolean)
  );
}

/**
 * @param {string} email
 * @returns {boolean}
 */
export function isExcludedDashboardUser(email) {
  const excluded = getExcludedDashboardEmailSet();
  if (excluded.size === 0) return false;
  return excluded.has(normalizeUserEmail(email));
}

/**
 * Filter top-user style rows by userEmail (UI only).
 * @param {Array<{ userEmail?: string }>} users
 * @returns {Array}
 */
export function filterDashboardUsers(users = []) {
  if (!Array.isArray(users) || users.length === 0) return [];
  const excluded = getExcludedDashboardEmailSet();
  if (excluded.size === 0) return users;
  return users.filter((user) => !excluded.has(normalizeUserEmail(user?.userEmail)));
}
